<template>
  <div>
    <field-select-module
      title="작성자 정보"
      :board="this.board"
      :is-print="isPrint"
      :typeslabel="{
          date: '등록일',
        }"
      v-model="form.stdInfo"
    />
    <!-- 위험성평가 정보 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 위험성평가 실시 현황</h5>
        </vs-col>
      </vs-row>
      <div class="overflow-x-auto">
        <table class="w-full">
          <colgroup>
            <col />
            <col />
            <col />
            <col width="110"/>
            <col width="110"/>
            <col width="110"/>
            <col width="110"/>
            <col width="110"/>
            <col />
            <col width="110"/>
            <col width="110"/>
            <col />
          </colgroup>
          <thead>
          <tr>
            <th rowspan="2">실시시기(예정)</th>
            <th rowspan="2">실시방법</th>
            <th rowspan="2">업체명</th>
            <th colspan="5">직종</th>
            <th rowspan="2">위험성 감소대책<br>실행 건수</th>
            <th rowspan="2">근로자 참여</th>
            <th rowspan="2">근로자 교육</th>
            <th rowspan="2">비고</th>
          </tr>
          <tr>
            <th>조리</th>
            <th>시설</th>
            <th>청소</th>
            <th>과학실험실</th>
            <th>사무실</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <ml-input class="w-full" style="min-width: 198px;" v-model="form.실시시기" :readonly="board.readonly" placeholder="입력필드" />
            </td>
            <td>
              <vs-select class="w-full" style="min-width: 70px;" v-model="form.실시방법" autocomplete :readonly="board.readonly">
                <vs-select-item text="1" value="1" />
                <vs-select-item text="2" value="2" />
                <vs-select-item text="3" value="3" />
              </vs-select>
            </td>
            <td>
              <ml-input class="w-full" style="min-width: 198px;" v-model="form.업체명" :readonly="board.readonly" placeholder="입력필드" />
            </td>
            <td>
              <div class="flex">
                <vs-radio class="mr-4" v-model="form.조리" vs-name="조리" :readonly="board.readonly" vs-value="O">O</vs-radio>
                <vs-radio class="mr-4" v-model="form.조리" vs-name="조리" :readonly="board.readonly" vs-value="X">X</vs-radio>
              </div>
            </td>
            <td>
              <div class="flex">
                <vs-radio class="mr-4" v-model="form.시설" vs-name="시설" :readonly="board.readonly" vs-value="O">O</vs-radio>
                <vs-radio class="mr-4" v-model="form.시설" vs-name="시설" :readonly="board.readonly" vs-value="X">X</vs-radio>
              </div>
            </td>
            <td>
              <div class="flex">
                <vs-radio class="mr-4" v-model="form.청소" vs-name="청소" :readonly="board.readonly" vs-value="O">O</vs-radio>
                <vs-radio class="mr-4" v-model="form.청소" vs-name="청소" :readonly="board.readonly" vs-value="X">X</vs-radio>
              </div>
            </td>
            <td>
              <div class="flex">
                <vs-radio class="mr-4" v-model="form.과학실험실" vs-name="과학실험실" :readonly="board.readonly" vs-value="O">O</vs-radio>
                <vs-radio class="mr-4" v-model="form.과학실험실" vs-name="과학실험실" :readonly="board.readonly" vs-value="X">X</vs-radio>
              </div>
            </td>
            <td>
              <div class="flex">
                <vs-radio class="mr-4" v-model="form.사무실" vs-name="사무실" :readonly="board.readonly" vs-value="O">O</vs-radio>
                <vs-radio class="mr-4" v-model="form.사무실" vs-name="사무실" :readonly="board.readonly" vs-value="X">X</vs-radio>
              </div>
            </td>
            <td>
              <ml-input class="w-full" style="min-width: 120px;" v-model="form.실행건수" type="number" :readonly="board.readonly" placeholder="입력필드" />
            </td>
            <td>
              <div class="flex">
                <vs-radio class="mr-4" v-model="form.근로자참여" vs-name="근로자참여" :readonly="board.readonly" vs-value="O">O</vs-radio>
                <vs-radio class="mr-4" v-model="form.근로자참여" vs-name="근로자참여" :readonly="board.readonly" vs-value="X">X</vs-radio>
              </div>
            </td>
            <td>
              <div class="flex">
                <vs-radio class="mr-4" v-model="form.근로자교육" vs-name="근로자교육" :readonly="board.readonly" vs-value="O">O</vs-radio>
                <vs-radio class="mr-4" v-model="form.근로자교육" vs-name="근로자교육" :readonly="board.readonly" vs-value="X">X</vs-radio>
              </div>
            </td>
            <td>
              <ml-input class="w-full" style="min-width: 198px;" v-model="form.비고" :readonly="board.readonly" placeholder="입력필드" />
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>
<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  components: {
    FieldSelector, DateSelector,
    FileUploadModule,
    FieldSelectModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        "실시시기": '',
        "실시방법": '',
        "업체명": '',
        "실행건수": '',
        "비고": '',
        "근로자참여": '',
        "근로자교육": '',

        "조리": '',
        "시설": '',
        "청소": '',
        "과학실험실": '',
        "사무실": '',
      }
    };
  },
};
</script>

<style scoped lang="scss">
table {
  border-spacing: 0px;

  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;

  th {
    padding: 0.5rem;
    text-align: center;
    background-color: #F9F9F9;

    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }
  td {
    padding: 0.5rem;

    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }
}

</style>
